import { datadogRum } from '@datadog/browser-rum';

export class DatadogTrack {
  public static action = (name: string, properties?: object) => {
    datadogRum.addAction(name, properties);
  };

  public static error = (error: Error) => {
    datadogRum.addError(error, undefined);
  };

  public static addLoadingTiming = () => {
    datadogRum.addTiming('page_loading');
  };
}
